import React from 'react';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import {useTranslation} from "react-i18next";

const DocumentTemplates = ({templates}) => {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <Grid item xs={12}>
                <Typography variant="h6">
                    {t('document_templates')}:
                </Typography>
            </Grid>
            {Object.keys(templates).length > 0
                ? Object.keys(templates).map(groupDocuments => {
                    let label = null;
                    switch (groupDocuments) {
                        case 'agreement':
                            label = t('enrollment_consent');
                            break;
                        case 'rejection':
                            label = t('enrollment_refusal');
                            break;
                    }
                    return (
                        <Grid item xs={12} key={groupDocuments}>
                            <Typography component={'p'} variant="body1">
                                {label ? label : null}
                            </Typography>
                            <Typography component={'ul'} variant="body1">
                                {templates[groupDocuments].map(document => {
                                    return (
                                        <li key={document.id}>
                                            <Link href={document.href} target="_blank">
                                                {document.title}
                                            </Link>
                                        </li>
                                    );
                                })}
                            </Typography>
                        </Grid>
                    );
                })
                : <Grid item xs={12}><Typography variant="body1">{t('no_templates')}</Typography></Grid>}
        </React.Fragment>
    );
};
export default DocumentTemplates;